import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { FullMasterTemplate } from '@/modules/@appbase/templates'
import DesignPersonal from '@webparts/components/template-design/TemplateDesignPersonal.vue'

@Component({
  components: { FullMasterTemplate, DesignPersonal },
  computed: {
    ...mapGetters({
    }),
  },
})
export default class WebpartPersonalView extends Vue {
  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //
  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //
  

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

}
